import React from 'react';
import { useParams } from 'react-router-dom';
import CreateVendorOnboarding from './CreateVendorOnboarding';

const ViewVendorOnboarding = () => {
  const { id } = useParams();

  return <CreateVendorOnboarding viewMode={true} vendorId={id} />;
};

export default ViewVendorOnboarding;

